// レイアウトコンポーネント

import React from 'react';
import { Outlet } from 'react-router-dom';
import BCPPageHeader from './BCPPageHeader';
import { useHeaderMenuItems } from '../hooks/useHeaderMenuItems';

const Layout: React.FC = () => {
  const headerMenuItems = useHeaderMenuItems();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* ヘッダー - 統一デザイン（TOPへ戻るボタンのみ） */}
      <BCPPageHeader
        showActions={false}
        menuItems={headerMenuItems}
      />

      {/* メインコンテンツ */}
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
        <Outlet />
      </main>

      {/* フッター */}
      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center text-sm text-gray-500">
            <p>&copy; 2025 SONAE-AI. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
